/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import PropTypes from "prop-types";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";
import Footer from "layouts/authentication/components/Footer";
import colors from "assets/theme/base/colors";
import tripleLinearGradient from "assets/theme/functions/tripleLinearGradient";
import GradientBorder from "examples/GradientBorder";
import borders from "assets/theme/base/borders";

function CoverLayout({
  color,
  header,
  title,
  description,
  motto,
  premotto,
  image,
  top,
  cardContent,
  children,
}) {
  const { gradients } = colors;
  return (
    <PageLayout
      // background={tripleLinearGradient(
      //   gradients.cover.main,
      //   gradients.cover.state,
      //   gradients.cover.stateSecondary,
      //   gradients.cover.angle
      // )}
      backgroundImage={`url(${image})`}
      // backgroundSize="cover"
      backgroundPosition="center"
      backgroundRepeat="no-repeat"
    >
      <VuiBox
        sx={{
          display: "flex",
          justifyContent: "center",
          position: "relative",
          alignItems: "center",
          maxWidth: "100%",
          minHeight: "100vh",
          margin: "0 auto",
        }}
      >
        <VuiBox
          sx={{
            mx: "auto",
            width: "100%",
          }}
        >
          <VuiBox pt={3} px={3} mx="auto !important" maxWidth={cardContent ? "420px" : "350px"}>
            {!header ? (
              <>
                <VuiBox mb="10px">
                  <VuiTypography
                    textAlign={cardContent ? "center" : "start"}
                    variant="h3"
                    fontWeight="bold"
                    color={color}
                    mb="10px"
                  >
                    {title}
                  </VuiTypography>
                  <VuiTypography
                    textAlign={cardContent ? "center !important" : "start !important"}
                    mx="auto"
                    color={color}
                    sx={({ typography: { size }, functions: { pxToRem } }) => ({
                      fontWeight: "regular",
                      fontSize: size.sm,
                    })}
                  >
                    {description}
                  </VuiTypography>
                </VuiBox>
              </>
            ) : (
              header
            )}
          </VuiBox>
          <VuiBox
            px={3}
            mb="50px"
            mx="auto"
            ml="auto !important"
            sx={({ breakpoints }) => ({
              mt: cardContent ? "20px" : { top },
              // width: cardContent ? "470px" : "350px",
              maxWidth: cardContent ? "420px" : "350px",
              // [breakpoints.down("xl")]: {
              //   mr: cardContent ? "0px" : "100px",
              // },
              // [breakpoints.only("lg")]: {
              //   mr: "auto",
              //   ml: "auto !important",
              // },
              // [breakpoints.down("lg")]: {
              //   mr: "auto",
              //   ml: "auto !important",
              // },
              // [breakpoints.down("md")]: {
              //   mr: cardContent ? "auto !important" : "unset",
              //   pr: "7px",
              //   pl: cardContent ? "0px !important" : "10px !important",
              // },
            })}
          >
            {children}
          </VuiBox>
        </VuiBox>
      </VuiBox>
    </PageLayout>
  );
}

// Setting default values for the props of CoverLayout
CoverLayout.defaultProps = {
  header: "",
  title: "",
  description: "",
  color: "light",
  top: 20,
};

// Typechecking props for the CoverLayout
CoverLayout.propTypes = {
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string.isRequired,
  top: PropTypes.number,
  children: PropTypes.node.isRequired,
};

export default CoverLayout;
